import React from 'react';

import Navbar from 'Containers/Navbar';

const Sticky = ({children, hideNavbar})=> {
    return (
        <div className="sticky">
            {!hideNavbar && <Navbar />}
            <div className="main-page" style={hideNavbar ? { paddingTop: 0 } : undefined}>
                {children}
            </div>
        </div>
    )
}

export default Sticky;